import { PartnersType } from 'src/types';

export const getPartnerKey = () =>
    window.location.host.split('.')[0] as PartnersType;
